export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f6a859227f36fba4801aaab16a93551f6d48ffbb6&name=fetchTypeahead!'